import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Award, Download, Loader2, Printer } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const ParentCertificateCard = ({ token, studentName }) => {
  const [url, setUrl] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!token) return;
    let objectUrl;
    fetch(`${API}/api/certificates/parent/${token}.png`)
      .then(async (r) => {
        if (!r.ok) throw new Error();
        objectUrl = URL.createObjectURL(await r.blob());
        setUrl(objectUrl);
        setState('ready');
      })
      .catch(() => setState('unavailable'));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [token]);

  if (state === 'unavailable') return null;

  return (
    <Card className="shadow-lg border-amber-200" data-testid="parent-certificate-card">
      <CardHeader className="bg-amber-50">
        <CardTitle className="flex items-center gap-2"><Award className="h-5 w-5 text-amber-600" /> Certificate of Completion</CardTitle>
        <CardDescription>{studentName ? `${studentName}'s` : "Your child's"} end-of-year certificate from the school</CardDescription>
      </CardHeader>
      <CardContent className="pt-6">
        {state === 'loading' ? (
          <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-amber-600" /></div>
        ) : (
          <div className="space-y-4">
            <img src={url} alt="Certificate" className="w-full rounded-lg shadow border" data-testid="parent-certificate-image" />
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => { const w = window.open(url, '_blank'); w?.addEventListener('load', () => w.print()); }} className="gap-2" data-testid="parent-certificate-print"><Printer className="h-4 w-4" /> Print</Button>
              <Button asChild className="gap-2 bg-amber-600 hover:bg-amber-700"><a href={url} download={`${(studentName || 'Student').replace(/[^A-Za-z0-9]+/g, '_')}_Certificate.png`} data-testid="parent-certificate-download"><Download className="h-4 w-4" /> Download</a></Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
